<template>
  <section class="reimburse-box">
      <img class="top" src="../../assets/img/guide/top.png" alt="">
      <div class="content">
        <h5>打开推推应用中心/财务相关填写费用报销</h5>
        <img class="move-img" src="../../assets/img/guide/move.png" alt="">
        <h5>下载推推</h5>
        <img class="qrcode-img" src="../../assets/img/guide/qrcode.png" alt="">
      </div>
  </section>
</template>

<script>
  export default {
    name: 'reimburse'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.reimburse-box{
  min-height: calc(100vh - 13px);
  padding-bottom: 13px;
  background: url('../../assets/img/guide/bg.png') no-repeat;
  background-size: cover;
  img{
    margin: 0 auto;
  }
  .top{
    padding: 16px 0;
    display: block;
    width: 375px;
    height: 72px;
  }
  .content{
    width: 345px;
    border-radius: 20px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.16);
    margin: 0 auto;
    padding: 9px 0;
    h5{
      text-align: center;
      color: rgb(78, 116, 187);
      font-weight: normal;
      line-height: 40px;
      font-size: 16px;
    }
    .move-img{
      width: 320px;
      height: 275px;
    }
    .qrcode-img{
      width: 193.5px;
      height: 118px;
    }
  }
}
</style>
